import {Component, inject, OnInit, RESPONSE_INIT} from '@angular/core';
import {PageTitleComponent} from "../../components/page-title/page-title.component";
import {ButtonDirective, ButtonLabel} from "primeng/button";
import {RouterLink} from "@angular/router";

@Component({
  standalone: true,
  imports: [
    PageTitleComponent,
    ButtonDirective,
    ButtonLabel,
    RouterLink
  ],
  templateUrl: './not-found-page.component.html',
})
export class NotFoundPageComponent implements OnInit {
    private readonly responseInit = inject(RESPONSE_INIT, { optional: true });

    ngOnInit(): void {
       console.error('404 Page loaded');
       if (this.responseInit) {
         this.responseInit.status = 404;
       }
    }
}
